module.exports = __webpack_public_path__ + "img/Back Bumper.1815d6fe.png";